import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import MovieCard from '../components/MovieCard';
import SkeletonCard from '../components/ui/SkeletonCard';
import { getMovieRequest } from '../api/api';

const Selected = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [startActor, setStartActor] = useState(null);
  const [actors, setActors] = useState(null);
  const [loading, setLoading] = useState(false);

  const loadActors = useCallback(async (signal) => {
    setLoading(true);
    setActors(null);
    const data = await getMovieRequest();
    if (signal?.aborted) return;
    if (data) setActors(data.results);
    setLoading(false);
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    loadActors(controller.signal);
    return () => controller.abort();
  }, [loadActors]);

  const handleActorClick = (actor) => {
    if (step === 1) {
      setStartActor(actor);
      setStep(2);
      loadActors();
    } else {
      navigate('/ingame', { state: { startActor, endActor: actor } });
    }
  };

  return (
    <div className="min-h-screen bg-[#fdf6ec] px-4 py-8">
      <div className="max-w-sm mx-auto">

        <div className="flex items-center justify-between mb-4">
          <div>
            <span className="bg-[#ff6b35] text-white text-xs font-black tracking-[3px] uppercase px-3 py-1 rounded">
              FILMQUEST
            </span>
            <h1 className="text-xl font-black text-[#1a1a1a] mt-2">Pick Your Actors</h1>
          </div>
          <button
            onClick={() => navigate('/')}
            className="bg-white text-[#1a1a1a] font-black text-sm py-2 px-4 rounded-lg border-[3px] border-[#1a1a1a] shadow-[3px_3px_0_#1a1a1a] hover:shadow-[1px_1px_0_#1a1a1a] transition-shadow"
          >
            ← Back
          </button>
        </div>

        <div className="flex items-center gap-2 mb-4">
          <span className="bg-[#ff6b35] text-white text-xs font-black px-3 py-1 rounded-full border-2 border-[#1a1a1a]">
            Step {step} of 2
          </span>
          <span className="text-sm font-bold text-[#1a1a1a]">
            {step === 1 ? 'Pick your START actor' : 'Pick your GOAL actor'}
          </span>
        </div>

        {step === 2 && startActor && (
          <div className="bg-[#ff6b3515] border-2 border-[#ff6b35] rounded-xl p-3 mb-4 flex items-center gap-2">
            <span className="text-xs font-black text-[#ff6b35] uppercase tracking-wider flex-shrink-0">
              Connecting from:
            </span>
            <span className="text-sm font-bold text-[#1a1a1a]">{startActor.name}</span>
          </div>
        )}

        <div className="flex justify-between items-center mb-3">
          <p className="text-xs text-[#888] font-semibold">
            Don't recognise anyone?
          </p>
          <button
            onClick={loadActors}
            disabled={loading}
            className="bg-white text-[#1a1a1a] font-black text-xs py-1.5 px-3 rounded-lg border-2 border-[#1a1a1a] shadow-[2px_2px_0_#ff6b35] hover:shadow-[1px_1px_0_#ff6b35] transition-shadow disabled:opacity-40"
          >
            🔄 Refresh
          </button>
        </div>

        <div className="flex flex-col gap-3">
          {loading || !actors
            ? Array.from({ length: 8 }).map((_, i) => <SkeletonCard key={i} />)
            : actors.map(actor => (
                <MovieCard
                  key={actor.id}
                  itemId={actor.id}
                  itemTitle={actor.name}
                  itemRole={actor.known_for_department}
                  itemImgUrl={actor.profile_path}
                  isActor={true}
                  onClickFunction={() => handleActorClick(actor)}
                />
              ))
          }
        </div>

      </div>
    </div>
  );
};

export default Selected;
